export const KEY = 'AttivaAppState';

export function loadState() {
  try {
    const serializedState = localStorage.getItem(KEY);
    if (!serializedState) return undefined;

    const state = JSON.parse(serializedState);

    state.auth.loading = false;

    if (state.table?.['contracts-table']?.columnVisibility) {
      const visibility = state.table['contracts-table'].columnVisibility;
      if (visibility.currentContractBlockedStatusDate !== undefined) {
        if (visibility.currentBlockedStatusDate === undefined) {
          visibility.currentBlockedStatusDate = visibility.currentContractBlockedStatusDate;
        }
        delete visibility.currentContractBlockedStatusDate;
      }
    }

    return state;
  } catch (e) {
    return undefined;
  }
}

export async function saveState(state: any) {
  try {
    const serializedState = JSON.stringify(state);
    localStorage.setItem(KEY, serializedState);
  } catch (e) {
    // Ignore
  }
}